export default __webpack_public_path__ + "static/card4-f91b6172c70eba6740f1ce094cef91ad.png";